import * as actions from "Actions";
import * as api from "Api";

export const fetchCapacityPlaningCollaboratorKPI = (id, date, erpId) => {
  return (dispatch, getState) => {
    const { currentOrganization } = getState().auth;
    return dispatch(
      actions.getCapacityPlaningCollaboratorKPI(
        api.getCapacityPlaningCollaboratorKPI(
          currentOrganization.id,
          id,
          date,
          erpId
        )
      )
    );
  };
};
export const fetchCapacityPlaningCollaboratorClient = date => {
  return (dispatch, getState) => {
    const {
      role,
      qp,
      analysisPlan,
      isAnnual,
      clientName
    } = getState().capacityPlaning.collaborator.filter;
    const { collaborator } = getState().capacityPlaning.collaborator;

    const { currentOrganization } = getState().auth;
    return dispatch(
      actions.getCapacityPlaningCollaboratorClient(
        api.getCapacityPlaningCollaboratorClient(
          currentOrganization.id,
          collaborator.id,
          collaborator.erpId,
          analysisPlan,
          role,
          qp,
          date,
          isAnnual,
          clientName
        )
      )
    );
  };
};

export const fetchCapacityPlaningProduction = () => {
  return (dispatch, getState) => {
    const {
      analyseDate,
      searchWord,
      collaboratorState
    } = getState().capacityPlaning.production.filter;
    const {
      entityClientId: { deletedStatus }
    } = getState().clients.filter;
    const { currentOrganization } = getState().auth;

    return dispatch(
      actions.getCapacityPlaningProduction(
        api.getCapacityPlaningProduction(
          currentOrganization.id,
          analyseDate,
          searchWord,
          collaboratorState,
          deletedStatus
        )
      )
    );
  };
};

export const fetchCollaboratorFinancial = date => {
  return (dispatch, getState) => {
    const { collaborator } = getState().capacityPlaning.collaborator;
    const { searchWord } = getState().financialSheet.periodFilter.searchWord;
    const {
      filter: {
        deletedStatus,
        clientCRMGroup,
        clientCRMTypes,
        collaboratorRole,
        collaboratorAttribution
      }
    } = getState().financialSheet.periodTree;
    const { sortBy } = getState().financialSheet.periodFilter;

    const { currentOrganization } = getState().auth;
    return dispatch(
      actions.getCollaboratorFinancial(
        api.getCollaboratorFinancial(
          currentOrganization.id,
          collaborator.id,
          collaboratorRole,
          collaboratorAttribution,
          date,
          sortBy.selected,
          clientCRMGroup,
          clientCRMTypes,
          deletedStatus,
          searchWord
        )
      )
    );
  };
};

export const fetchGroupedCapacityPlaningClients = () => {
  return (dispatch, getState) => {
    const { currentOrganization } = getState().auth;
    const {
      collaborator: { id }
    } = getState().capacityPlaning.collaborator;

    const {
      client,
      searchWord: { searchWord }
    } = getState().financialSheet.periodFilter;

    const {
      filter: { year }
    } = getState().budget.dynamicTable;
    const {
      filter: { clientTypes, clientCRMTypes, clientCRMGroup }
    } = getState().financialSheet.periodTree;

    const {
      collaboratorBudgetSortBy,
      collaboratorRole,
      VATPeriodicity,
      closingDate
    } = getState().capacityPlaning.production.grouped.filter;
    const {
      entityClientId: { deletedStatus }
    } = getState().clients.filter;

    return dispatch(
      actions.getGroupedCapacityPlaningClients(
        api.getGroupedCapacityPlaningClients(
          currentOrganization.id,
          year,
          searchWord,
          id,
          JSON.stringify(clientTypes),
          JSON.stringify(clientCRMTypes),
          clientCRMGroup,
          client.selected,
          collaboratorRole.selected,
          collaboratorBudgetSortBy.selected,
          VATPeriodicity,
          closingDate.selected,
          deletedStatus
        )
      )
    );
  };
};

export const exportCapacityDossierSheet = collaboratorName => {
  return (dispatch, getState) => {
    const { currentOrganization } = getState().auth;
    const {
      collaborator: { id }
    } = getState().capacityPlaning.collaborator;

    const {
      client,
      searchWord: { searchWord }
    } = getState().financialSheet.periodFilter;

    const {
      filter: { year }
    } = getState().budget.dynamicTable;
    const {
      filter: { clientTypes, clientCRMTypes, clientCRMGroup }
    } = getState().financialSheet.periodTree;

    const {
      collaboratorBudgetSortBy,
      collaboratorRole,
      VATPeriodicity,
      closingDate
    } = getState().capacityPlaning.production.grouped.filter;
    const {
      entityClientId: { deletedStatus }
    } = getState().clients.filter;

    return dispatch(
      actions.exportCapacityDossier(
        api.exportCapacityDossier(
          currentOrganization.id,
          year,
          searchWord,
          id,
          JSON.stringify(clientTypes),
          JSON.stringify(clientCRMTypes),
          clientCRMGroup,
          client.selected,
          collaboratorRole.selected,
          collaboratorBudgetSortBy.selected,
          VATPeriodicity,
          closingDate.selected,
          deletedStatus,
          collaboratorName
        )
      )
    );
  };
};



// WEBPACK FOOTER //
// ./src/actions/thunks/capacity.js